<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
        <TabView>
            <TabPanel header="ข้อมูลพื้นที่อพยพ">
                <initial-evacuation></initial-evacuation>
            </TabPanel>
            <TabPanel header="ข้อมูลระดับความเสี่ยง">
                <initial-risk-level></initial-risk-level>
            </TabPanel>
            <TabPanel header="ข้อมูลพื้นที่เสี่ยงภัย">
                <initial-risk-area></initial-risk-area>
            </TabPanel>
            <TabPanel header="ข้อมูลหน่วยงาน">
                <initial-organization></initial-organization>
            </TabPanel>
            <TabPanel header="ข้อมูลระบบป้องกัน/บรรเทาสาธารณภัย">
                <initial-disaster></initial-disaster>
            </TabPanel>
            <TabPanel header="ข้อมูลหลักสูตรการฝึกอบรม">
                <initial-course></initial-course>
            </TabPanel>
            <TabPanel header="ข้อมูลกำลังคน">
                <initial-man></initial-man>
            </TabPanel>
            <TabPanel header="ข้อมูลอุปกรณ์สำนักงาน">
                <initial-device></initial-device>
            </TabPanel>
            <TabPanel header="ข้อมูลชุดเผชิญเหตุ">
                <initial-incident></initial-incident>
            </TabPanel>
            <TabPanel header="ข้อมูลเครื่องมือ อุปกรณ์/ยานพาหนะ">
                <initial-equipment-vehicle></initial-equipment-vehicle>
            </TabPanel>
            <TabPanel header="ข้อมูลอาคาร/สิ่งปลูกสร้าง">
                <initial-building></initial-building>
            </TabPanel>
            <TabPanel header="UN Number">
                <initial-UNNumber></initial-UNNumber>
            </TabPanel>
            <TabPanel header="ข้อมูลหัวจ่ายน้ำดับเพลิง">
                <initial-FireHydrant></initial-FireHydrant>
            </TabPanel>
            <TabPanel header="ข้อมูลชุมชน">
                <initial-Community></initial-Community>
            </TabPanel>
            <TabPanel header="ข้อมูลสถานีดับเพลิงและกู้ภัย">
                <initial-FireStation></initial-FireStation>
            </TabPanel>
            <TabPanel header="เครื่องอุปโภค บริโภค">
                <initial-consumables></initial-consumables>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import initialEvacuation from './InformationEvacuationArea';
import initialRiskLevel from './InformationRiskLevel';
import initialRiskArea from './InformationRiskArea';
import initialOrganization from './InformationOrganization';
import initialDisaster from './InformationDisasterPrevent';
import initialCourse from './InformationTrainingCourse';
import initialMan from './InformationManPower';
import initialDevice from './InformationDevice';
import initialIncident from './InformationIncident';
import initialEquipmentVehicle from './InformationEquipmentVehicle';
import initialBuilding from './InformationBuilding';
import initialUNNumber from './InformationUNNumber';
import initialFireHydrant from './InformationFireHydrant';
import initialCommunity from './InformationCommunity';
import initialFireStation from './InformationFireStation';
import initialConsumables from './InformationConsumables';

export default {
    components: {
        initialEvacuation,
        initialRiskLevel,
        initialRiskArea,
        initialOrganization,
        initialDisaster,
        initialCourse,
        initialMan,
        initialDevice,
        initialIncident,
        initialEquipmentVehicle,
        initialBuilding,
        initialUNNumber,
        initialFireHydrant,
        initialCommunity,
        initialFireStation,
        initialConsumables
    },
    data() {
        return {};
    },

    watch: {},

    mounted() {},

    methods: {
        // handleTabChange(newTab){
        //     console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        // }
    }
};
</script>
